// extracted by mini-css-extract-plugin
module.exports = {"YourDetails":"YourDetails_YourDetails__1cpM5","FormGroup":"YourDetails_FormGroup__YH8zS"};